import { render, staticRenderFns } from "./AddExam.vue?vue&type=template&id=147268d0&scoped=true&"
import script from "./AddExam.vue?vue&type=script&lang=js&"
export * from "./AddExam.vue?vue&type=script&lang=js&"
import style0 from "./AddExam.vue?vue&type=style&index=0&id=147268d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147268d0",
  null
  
)

export default component.exports